// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageWrapper_wrapper__PGel7"};